module.exports = "/images/checkoutMoney.svg";